import { Flex, Icon, Text, TextProps } from '@chakra-ui/react'
import { getMapsUrl } from '../../pages/user/PlayExpand'
import { LocationMarkerDirection } from '../icons/icons'

interface ClickableAddressProps extends TextProps {
  address?: string
  showIcon?: boolean
}

// Shared tappable-address display. Reuses the canonical getMapsUrl helper so every
// surface opens the device maps/navigation app with identical behavior. Do NOT
// reimplement maps logic here — getMapsUrl is the single source of truth.
const ClickableAddress = ({ address, showIcon = false, ...textProps }: ClickableAddressProps) => {
  if (!address) return null

  const handleClick = (e: React.MouseEvent) => {
    // stopPropagation keeps this safe inside other interactive containers
    e.stopPropagation()
    window.open(getMapsUrl(address))
  }

  const text = (
    <Text cursor="pointer" _hover={{ textDecoration: 'underline' }} {...textProps}>
      {address}
    </Text>
  )

  if (!showIcon) {
    return (
      <Text cursor="pointer" _hover={{ textDecoration: 'underline' }} onClick={handleClick} {...textProps}>
        {address}
      </Text>
    )
  }

  return (
    <Flex align="center" gap="6px" w="fit-content" maxW="100%" cursor="pointer" onClick={handleClick}>
      <Icon w="15px" h="15px" viewBox="0 0 20 20" color="#7E8B9A" fill="none" flexShrink={0}>
        <LocationMarkerDirection />
      </Icon>
      {text}
    </Flex>
  )
}

export default ClickableAddress
